import React from "react";
import { STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE } from "../../consts/queries";
import PipelineTable from "../PipelineTable";
import { executeQuery } from "../../requests/executeQuery";
import { pipelineRoutes } from "../../consts/consts";
import { PipelineByStatusModel } from "./pipelineByStatusModel";
import filter from "../../filter";
import PipelineDetails from "../PipelineDetails/PipelineDetails";
import { STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE_QUERY } from "../Graphql/Queries/pipelineQuery";
import { ApolloConsumer } from "@apollo/client";
import { fetchData } from "../Service/graphQlService";
import moment from "moment";
const pipelineTitles = [
  {
    route: pipelineRoutes.active,
    title: "Active",
  },
  {
    route: pipelineRoutes.inNegotiation,
    title: "In Negotiation",
  },
  {
    route: pipelineRoutes.underContract,
    title: "Under Contract",
  },
  {
    route: pipelineRoutes.totalNegUc,
    title: "Total (In Neg/UC)",
  },
  {
    route: pipelineRoutes.inNegUcOther,
    title: "Other (Neg/Uc)",
  },
  {
    route: pipelineRoutes.closedYTD,
    title: "Closed YTD",
  },
  {
    route: pipelineRoutes.closedYTDOther,
    title: "Other Closed YTD",
  },
  {
    route: pipelineRoutes.totalClosedYTD,
    title: "Total Closed YTD",
  },
];

export default class PipelineByStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: {},
      rows: {},
      loading: false,
      status: "",
    };
    this.client = null
  }

  componentDidMount() {
    const status = this.props.routeParams.status;
    const title = pipelineTitles.find((obj) => {
      return obj.route === status;
    }).title;
    if(this.client){
        this.fetch(this.props.routeParams.status);
    }
    this.setState({ title, status });
  }

  static getColumns(status) {
    const cols = [];
    if (
      status === pipelineRoutes.closedYTD ||
      status === pipelineRoutes.closedYTDOther ||
      status === pipelineRoutes.totalClosedYTD
    ) {
      cols.push({
        name: "Close of Escrow",
        key: "CLOSE_OF_ESCROW",
        style: "center",
      });
    }

    if (status === pipelineRoutes.totalNegUc) {
      cols.push({
        name: "Status",
        key: "STATUS",
        class: "PipelineTable_align_left",
      });
    }
    if(status===pipelineRoutes.active){
      cols.push({
          name: 'Listing Date',
          key: 'LISTED_DATE',
          style: 'center',
      })
  } 
    cols.push(
      {
        name: "Property Name",
        key: "NAME",
        class: "PipelineTable_align_left",
        hasLink: "property",
      },
      {
        name: "Address",
        key: "ADDRESS",
        class: "PipelineTable_align_left",
      },
      {
        name: "City",
        key: "CITY",
        class: "PipelineTable_align_left",
      },
      {
        name: "State",
        key: "STATE",
        style: "center",
      }
    );

    let priceLabel = "";
    switch (status) {
      case pipelineRoutes.active:
        priceLabel = "List Price";
        break;
      case pipelineRoutes.inNegotiation:
      case pipelineRoutes.underContract:
      case pipelineRoutes.totalNegUc:
        priceLabel = "Price";
        break;
      case pipelineRoutes.closedYTD:
      case pipelineRoutes.closedYTDOther:
      case pipelineRoutes.totalClosedYTD:
        priceLabel = "Price at Close";
        break;
    }

    if (status !== pipelineRoutes.inNegUcOther)
      cols.push({
        name: priceLabel,
        key: "PRICE",
        style: "center",
        format: "$",
      });

    cols.push({
      name: "Gross Fee",
      key: "GROSS_FEE",
      style: "center",
      format: "$",
      withCents: 2,
    });

    if (![pipelineRoutes.active, pipelineRoutes.inNegUcOther].includes(status))
      cols.push(
        {
          name: "Split w/ Outside Agent",
          key: "SPLIT_W_OA",
          style: "center",
          format: "$",
          withCents: 2,
        },
        {
          name: "STRIVE Fee",
          key: "STRIVE_FEE",
          style: "center",
          format: "$",
          withCents: 2,
        }
      );

    return cols;
  }

  static getParams(status) {
    let params = {};
    const currentYear = new Date().getFullYear();

    switch (status) {
      case pipelineRoutes.active:
        params.LIST_PRICE = 1;
        params.STATUS = "Active";
        params.TRANSACTION_TYPE = "Investment Sales";
        break;
      case pipelineRoutes.inNegotiation:
        params.LIST_PRICE = 1;
        params.STATUS = "In Negotiation";
        params.TRANSACTION_TYPE = "Investment Sales";
        break;
      case pipelineRoutes.underContract:
        params.LIST_PRICE = 1;
        params.STATUS = "Under Contract";
        params.TRANSACTION_TYPE = "Investment Sales";
        break;
      case pipelineRoutes.inNegUcOther:
        params.STATUS = "In Negotiation,Under Contract";
        params.TRANSACTION_TYPE = "Advisory,Referral";
        break;
      case pipelineRoutes.closedYTD:
        params.CLOSE_OF_ESCROW = currentYear;
        params.SOLD_PRICE = 1;
        params.STATUS = "Closed";
        params.TRANSACTION_TYPE = "Investment Sales";
        params.BUYER_AGENT_4_FIRM = "34";
        break;
      case pipelineRoutes.closedYTDOther:
        params.CLOSE_OF_ESCROW = currentYear;
        params.STATUS = "Closed";
        params.TRANSACTION_TYPE = "Advisory,Referral";
        break;
      case pipelineRoutes.totalNegUc:
        params.LIST_PRICE = 1;
        params.STATUS = "In Negotiation,Under Contract";
        params.TRANSACTION_TYPE = "Investment Sales";
        break;
      case pipelineRoutes.totalClosedYTD:
        params.CLOSE_OF_ESCROW = currentYear;
        params.STATUS = "Closed";
        params.TRANSACTION_TYPE = "Investment Sales,Advisory,Referral";
        break;
    }
    return params;
  }
  fetch(status) {
    this.setState({ loading: true });
    const columns = PipelineByStatus.getColumns(status);
    const query = PipelineByStatus.getParams(status);
    const options = filter(query, "strivePipelineByStatus");
    const token = localStorage.getItem('authToken');
    const filteredParams = Object.fromEntries(
        Object.entries(options.param).filter(([key, value]) => value !== "NOMATCH" && value !== "")
      );
    // executeQuery({
    //   queryName: STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE,
    //   options,
    // })
    //  this.client.query({
    //      query: STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE_QUERY,
    //      variables: {
    //         params: filteredParams,
    //      },
    //      fetchPolicy: "no-cache",
    //      context: {
    //        headers: {
    //          authorization: `Bearer ${token}`, // Bearer token added here
    //        },
    //      },
    //    })

      fetchData( STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE_QUERY,
        {
           params: filteredParams,
        })
       .then((res) => {
         const state = {
           loading: false,
           rows: [],
           columns: columns,
         };

         if (
           res &&
           res &&
           res.data.strivePipelineByStatusAndTransactionType.success &&
           Array.isArray(res.data.strivePipelineByStatusAndTransactionType.data) &&
           res.data.strivePipelineByStatusAndTransactionType.data.length > 0 
         ) {
            res.data.strivePipelineByStatusAndTransactionType.data.map((row) => {
             if (status === pipelineRoutes.totalClosedYTD) {
               if (row.IS_OTHER === "1")
                 state.rows.push(
                   new PipelineByStatusModel({
                     data: row,
                     status: pipelineRoutes.closedYTDOther,
                   })
                 );
               else if (row.LIST_PRICE != null)
                 state.rows.push(
                   new PipelineByStatusModel({
                     data: row,
                     status: pipelineRoutes.closedYTD,
                   })
                 );
             } else
               state.rows.push(
                 new PipelineByStatusModel({ data: row, status })
               );
           });
           state.rows.push(
             new PipelineByStatusModel({ data: state.rows, isTotal: true })
           );
           state.rows = state.rows.length ? state.rows.map(res => {
            return {...res, LISTED_DATE: res.LISTED_DATE ? moment(res.LISTED_DATE).format('MM/DD/YYYY') : ''}
        }): []
         }

         this.setState(state);
       });
  }

  render() {
    const { rows, columns, title, loading } = this.state;
    const d = new Date();
    const date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();

    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) {
            this.client = client;
          }
          return (
            <div className="Pipeline">
              <div className="Pipeline_head">
                <div className="Pipeline_head_left">
                  <h3 className="Pipeline_h3">STRIVE Pipeline</h3>
                  <h4 className="Pipeline_h4">{date}</h4>
                  <h4 className="Pipeline_h4">
                    {title} - {rows.length ? rows.length - 1 : 0} Properties{" "}
                  </h4>
                </div>
              </div>
              {loading ? (
                <div className="loading">Loading data...</div>
              ) : (
                <PipelineTable
                  rows={rows}
                  columns={columns}
                  hasTotalRow={true}
                  className="list list-status"
                />
              )}
            </div>
          );
        }}
      </ApolloConsumer>
    );
  }
}
